const initialState = null;

const ClientReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_USER_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };

    case 'FETCH_CLIENT_SUCCESS':
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case 'FETCH_CLIENT_RESULTS_SUCCESS':
      return {
        ...state,
        loading: false,
        results: action.payload,
      };

    case 'FETCH_CLIENT_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default ClientReducer;
